<template>
  <div class="auth-container">
    <el-dialog :lock-scroll="true" v-if="globalDialog.loginVisible" class="el-dialog-sm" :close-on-click-modal="false" :visible.sync="globalDialog.loginVisible" @close="removeToken()">
      <Login :isDialog="true" v-on:success="close" class="passport-dialog"></Login>
    </el-dialog>
  </div>
</template>

<script>
import Login from './Login'

export default {
  name: 'LoginDialog',
  components: {
    Login: Login
  },
  computed: {
    globalDialog () {
	    return this.$store.state.globalDialog
    }
  },
  data () {
    return {
    }
  },
  created() {
  },
  methods: {
    close () {
      this.$store.commit('hideGlobalDialog', 'loginVisible')
    },
    removeToken (){
      this.$localStorage.remove('token')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/passport/LoginDialog.vue